module.exports = "<nm-page-header header=\"Users\"></nm-page-header>\n\n<div class=\"row\" *ngIf=\"data.user.isAdmin\">\n\t<div class=\"col-xs-12\">\n\t\t<a class=\"btn btn-sm btn-primary\" routerLink=\"/users/create\">New User</a>\n\t</div>\n</div>\n\n<div class=\"space-6\"></div>\n\n<div class=\"row\">\n\t<div class=\"col-xs-12\">\n\t\t<nm-datatable [settings]=\"datatableSetting\"></nm-datatable>\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/pages/users/users.html
// module id = 525
// module chunks = 0